import { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore'; 
import { auth, db } from '../firebase/config';

const UserContext = createContext();

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) throw new Error('useUser debe ser usado dentro de un UserProvider');
  return context;
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsubscribeFirestore = null;

    const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
      if (unsubscribeFirestore) {
        unsubscribeFirestore();
        unsubscribeFirestore = null;
      }

      setUser(currentUser);

      if (currentUser) {
        const userRef = doc(db, 'usuarios', currentUser.uid);

        unsubscribeFirestore = onSnapshot(userRef, (snapshot) => {
          if (snapshot.exists()) {
            const baseData = { id: snapshot.id, ...snapshot.data() };
            
            setUserData(baseData);
            setLoading(false);
          } else {
            console.error("Usuario autenticado pero sin documento en Firestore");
            setUserData(null);
            setLoading(false);
          }
        }, (error) => {
          if (error.code !== 'permission-denied') console.error("Error:", error);
          setLoading(false);
        });

      } else {
        setUserData(null);
        setLoading(false);
      }
    });

    return () => {
      if (unsubscribeFirestore) unsubscribeFirestore();
      unsubscribeAuth();
    };
  }, []);

  return (
    <UserContext.Provider value={{ user, userData, loading }}>
      {!loading && children}
    </UserContext.Provider>
  );
};